import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { LoginConstants } from 'src/environments/environment';
import { PayMent } from 'src/app/core/models/payment.model';
import { ApiService } from 'src/app/core/services/api.service';
import { TransactionsService } from 'src/app/core/services/transactions.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit {
  constructor(
    private svApi: ApiService,
    private aRoute: ActivatedRoute,
    private svTransaction: TransactionsService
  ) {}

  ngOnInit(): void {}
}
